import { Inject, Injectable } from "@angular/core";
import {
  manufacturerMapping,
  partMapping,
} from "../../../../shared/rm-mapping";
import { AppType, APP_TYPE } from "../app.type";
import { OverrideMpnFieldsServiceType } from "./override-mpnFields-service.type";
import { Customer } from "../../../../shared/types/customers";
import { StringUtils } from "../../../../shared/utils/string.utils";
import { Part } from "../../../../shared/models/part";
import { FieldTypes } from "../../../../shared/settings/settings";

@Injectable()
export class OverrideMpnFieldsService implements OverrideMpnFieldsServiceType {
  constructor(@Inject(APP_TYPE) private app: AppType) {}

  partKeys: string[] = [];
  manufacturerKeys: string[] = [];
  selectedField = "";
  openOverrideModal = false;

  async overrideFieldsFromOption(field: string, option: string) {
    if (
      field === this.app.fieldId.thread.artNumber ||
      field === this.app.fieldId.thread.crtNumber
    ) {
      this.selectedField = field;
      await this.app.manufacturer.prepareData(field, option);
    }
  }
  async setFieldsOnThread() {
    if (this.selectedField === this.app.fieldId.thread.artNumber) {
      this.copySelectedPartFieldsToThread();
      this.setDefaultChangeClassForCpnOnly();
    }
    if (this.selectedField === this.app.fieldId.thread.crtNumber) {
      this.copySelectedMpnFieldsToThread();
    }
    if (this.app.customers.expectCurrent === Customer.KNDS) {
      this.app.field.manufacturerCodes = [];
      this.app.thread.thread[this.app.fieldId.thread.cageCode] = "";

      let value: string =
        this.app.thread.thread[this.app.fieldId.thread.creator];
      if (!StringUtils.isNullOrEmpty(value)) {
        value = value.toUpperCase();
        await this.app.field.getManufacturerCodeByName(value);
      }
    }

    if (
      this.app.customers.expectCurrent === Customer.RHEINMETALLAIRDEFENCE ||
      this.app.customers.expectCurrent === Customer.RHEINMETALLITALY ||
      this.app.customers.expectCurrent === Customer.RWM
    ) {
      this.setThreadTitle(this.app.manufacturer.selectedPart);
    }
  }

  private copySelectedMpnFieldsToThread() {
    this.copySelectedPartFieldsToThread();
    this.app.thread.copyRmFieldsToThread(
      this.app.manufacturer.selectedManufacturer,
      manufacturerMapping
    );
  }

  private copySelectedPartFieldsToThread() {
    const selectedPart = this.app.manufacturer.selectedPart;

    if (selectedPart == null || Object.keys(selectedPart).length === 0) {
      return;
    }

    const mapping = { ...partMapping };
    const buyerField = this.app.fieldId.thread.buyer;
    if (this.app.field.getType(buyerField) === FieldTypes.userOptions) {
      mapping.sapDescription = null;
    }

    this.app.thread.copyRmFieldsToThread(selectedPart, mapping);
  }

  private setDefaultChangeClassForCpnOnly() {
    if (
      !this.app.thread.isNew ||
      !StringUtils.isNullOrEmpty(
        this.app.thread.thread[this.app.fieldId.thread.crtNumber]
      )
    ) {
      return;
    }

    const changeClasses =
      this.app.thread.thread[this.app.fieldId.thread.changeClasses];
    if (Array.isArray(changeClasses) && changeClasses.length > 0) {
      return;
    }

    this.app.thread.thread[this.app.fieldId.thread.changeClasses] = ["PDN"];
    this.app.thread.thread[this.app.fieldId.thread.creator_class] = "PDN";
  }

  private setThreadTitle(doc: Part) {
    const description = doc.description != null ? doc.description : "";

    this.app.thread.thread[this.app.fieldId.thread.title] =
      `${doc.partNumber}_${description}`;
  }
}
